import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import {Observable, of, switchMap, throwError} from "rxjs";
import { environment } from 'src/environments/environment';
import {HTTP_RESPONSE} from "../../utils/constants";
import { UserService } from './user/user.service';
import { HttpClient } from '@angular/common/http';
import {AuthUtils} from "../../utils/auth.utils";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private _authenticated: boolean = false;

  private API_URL = environment.api;
  private REMOTE_PUBLIC_REST = environment.publicRest;
  private REMOTE_EP_LOGIN = environment.endpoints.auth.login;
  private REMOTE_EP_LOGINGOOGLE = environment.endpoints.auth.loginGoogle;
  private REMOTE_EP_LOGININFOGOOGLE = environment.endpoints.auth.loginInfoGoogle;
  private REMOTE_EP_CREATEACCOUNT = environment.endpoints.auth.createAccount;

  constructor(
    private router: Router,
    private _httpClient: HttpClient,
    private _userService: UserService,
  ) { }

  // Get user session
  async getSession() {
    let session = {
      email: 'john.doe@mail.com'
    }
    return false;
    // return session;
  }

  signIn(credentials: { email: string; password: string }): Observable<any> {
    // Throw error, if the user is already logged in
    if (this._authenticated) {
      return throwError('User is already logged in.');
    }

    return this._httpClient.post(`${this.API_URL}/${this.REMOTE_PUBLIC_REST}${this.REMOTE_EP_LOGIN}`, credentials).pipe(
      switchMap((response: any) => {
        if(response?.tipo == HTTP_RESPONSE.SUCCESS){
          this.accessToken = response.data?.token;
          this.userSession = response.data?.user;
          this._authenticated = true;
          this._userService.user = response.data?.user;
        }
        return of(response);
      })
    );
  }

  signInTokenGoogle(idToken: string) {
    //console.log("signInTokenGoogle - idToken: ", idToken);

    return this._httpClient.post(`${this.API_URL}/${this.REMOTE_PUBLIC_REST}${this.REMOTE_EP_LOGINGOOGLE}`, { id_token: idToken }).pipe(
      switchMap((response: any) => {
        if(response?.tipo == HTTP_RESPONSE.SUCCESS){
          this.accessToken = response.data?.token;
          this.userSession = response.data?.user;
          this._authenticated = true;
          this._userService.user = response.data?.user;
        }
        return of(response);
      })
    );
  }

  signInInfoGoogle(params: any) {
    //console.log("signInInfoGoogle - params: ", params);

    return this._httpClient.post(`${this.API_URL}/${this.REMOTE_PUBLIC_REST}${this.REMOTE_EP_LOGININFOGOOGLE}`, params).pipe(
      switchMap((response: any) => {
        if(response?.tipo == HTTP_RESPONSE.SUCCESS){
          this.accessToken = response.data?.token;
          this.userSession = response.data?.user;
          this._authenticated = true;
          this._userService.user = response.data?.user;
        }
        return of(response);
      })
    );
  }

  createAccount(params: any) {
    //console.log("signInInfoGoogle - params: ", params);

    return this._httpClient.post(`${this.API_URL}/${this.REMOTE_PUBLIC_REST}${this.REMOTE_EP_CREATEACCOUNT}`, params).pipe(
      switchMap((response: any) => {
        if(response?.tipo == HTTP_RESPONSE.SUCCESS){
          this.accessToken = response.data?.token;
          this.userSession = response.data?.user;
          this._authenticated = true;
          this._userService.user = response.data?.user;
        }
        return of(response);
      })
    );
  }

  set accessToken(token: string) {
    localStorage.setItem('accessToken', token);
  }

  get accessToken(): string {
    return localStorage.getItem('accessToken') ?? '';
  }

  set userSession(userObj: any) {
    localStorage.setItem('userId', userObj?.id);
    localStorage.setItem('userName', userObj?.name);
    localStorage.setItem('userEmail', userObj?.email);
    localStorage.setItem('userAvatar', userObj?.avatar);
    localStorage.setItem('userStatus', userObj?.status);
    localStorage.setItem('userExpire', userObj?.expire);
  }

  get userSession(): any {
    return {
      id : localStorage.getItem('userId') ?? '',
      name : localStorage.getItem('userName') ?? '',
      email : localStorage.getItem('userEmail') ?? '',
      avatar : localStorage.getItem('userAvatar') ?? '',
      status : localStorage.getItem('userStatus') ?? '',
      expire : localStorage.getItem('userExpire') ?? '',
    };
  }

  /**
   * Check the authentication status
   */
  check(): Observable<boolean> {
    // Check if the user is logged in
    if (this._authenticated) {
      return of(true);
    }

    // Check the access token availability
    if (!this.accessToken) {
      return of(false);
    }

    // Check the access token expire date
    //if (AuthUtils.isTokenExpired(this.accessToken)) {
    if (AuthUtils.isTokenExpiredDACHA(localStorage.getItem('userExpire') ?? '')) {
      return of(false);
    }

    // If the access token exists, and it didn't expire, sign in using it
    //return this.signInUsingToken();

    // If the access token exists, and it didn't expire, sign in using it
    this._authenticated = true;
    this._userService.user = this.userSession;
    // Return true
    return of(true);
  }

  signOut(): Observable<any> {
    // Remove the access token from the local storage
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userAvatar');
    localStorage.removeItem('userStatus');
    localStorage.removeItem('userExpire');

    // Set the authenticated flag to false
    this._authenticated = false;

    // Return the observable
    return of(true);
  }


}
